// import config from 'config';

/* eslint-disable */
import { auth_host } from '../constants/service';
import { beacon_host } from '../constants/service';
import { ccp_host } from '../constants/service';
import { msal_config } from '../constants/service';
import { PublicClientApplication } from '@azure/msal-browser';
const userlogin = 'islogged';
const loginExpiryKey = 'tokenExpiry';
const Userinfo = 'userinfo';

export const requestService = {
  GetFetch,
  PostFetch,
  PostCcpFetch,
  PutFetch,
  DeleteFetch,
  refreshToken,
};

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('userinfo');
  localStorage.removeItem('tokenExpiry');
  localStorage.removeItem('islogged');
}
async function refreshToken_old(){
    let msalInstance = new PublicClientApplication(msal_config);
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length >0){
        var silentRequest = {
            scopes: ["User.Read"],
            account: accounts[0],
        };
    }else{
        logout();
        location.reload(true);
        return;
    }
    await msalInstance.acquireTokenSilent(silentRequest).then(function (accessTokenResponse){
        const timestampInSeconds = Math.floor(accessTokenResponse.expiresOn.getTime() / 1000);
        var userInfo = getLocalStorageUserInfo();
        userInfo.access_token_ms=accessTokenResponse.accessToken
        userInfo.exp_ms=timestampInSeconds
        localStorage.setItem(loginExpiryKey, timestampInSeconds);
        localStorage.setItem(Userinfo, JSON.stringify(userInfo));
    }).catch(async (error) => {
        console.log(error)
        logout();
        location.reload(true);
        return;
    });
}

async function refreshToken() {
  try {
    const userInfo = getLocalStorageUserInfo();
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userInfo.refresh_token
      },
      body: null
    };

    const url = auth_host + `/api/refresh_token`;
    const response = await fetch(url, requestOptions);
    const text = await response.text();
    const data = text && JSON.parse(text);

    if (data.message === "ok") {
      const newExpireToken = getJwtExpiration(data.access_token);
      localStorage.setItem('tokenExpiry', newExpireToken);

      userInfo.access_token = data.access_token;
      userInfo.exp = newExpireToken;

      localStorage.setItem(Userinfo, JSON.stringify(userInfo));
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Refresh token error:", error);
    return false;
  }
}

// async function refreshToken(){
//   var userInfo = getLocalStorageUserInfo();
//   const requestOptions = {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer '+userInfo.refresh_token },
//     body: null
//   };
//   var url = auth_host + `/api/refresh_token`;
//   (await fetch(url, requestOptions)).text().then((text) => {
//     const data = text && JSON.parse(text);
//     if (data.message == "ok") {
//       var newExpireToken = getJwtExpiration(data.access_token);
//       localStorage.setItem('tokenExpiry',newExpireToken);
//       userInfo.access_token = data.access_token;
//       userInfo.exp = data.newExpireToken;
//       console.log('new: ', data);

//       localStorage.setItem(Userinfo, JSON.stringify(userInfo));
//       return true;
//     } else {
//       return false;
//     }
//   })
//   .catch(() => {
//     return false;
//   });
// }

function getJwtExpiration(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  //const payload = Buffer.from(base64, 'base64').toString('ascii');
  const payload = window.atob(base64);
  const parsedPayload = JSON.parse(payload);
  return parsedPayload.exp;
}
////////////////////// Host Beacon////////////////////
async function GetFetch(module,path) {
  if (localStorage.getItem(loginExpiryKey) - Math.floor(new Date().getTime() / 1000) <=0){
      await refreshToken()
  }
  var userInfo = getLocalStorageUserInfo();
  if (userInfo == undefined) {
    logout();
    location.reload(true);
    return;
  }
  var token = userInfo.access_token;
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  };
  switch(module) {
      case "auth":
        var url = auth_host + path;
        break;
      case "beacon":
        var url = beacon_host + path;
        break;
      case "ccp":
        var url = ccp_host + path;
        break;
      default:
        // code block
  }
  // var url = beacon_host + path;
  return fetch(url, requestOptions).then(handleResponseStatus);
}

async function PutFetch(module,path, object, form = null) {
  if (localStorage.getItem(loginExpiryKey) - Math.floor(new Date().getTime() / 1000) <=0){
    await refreshToken()
}
var userInfo = getLocalStorageUserInfo();
var token = userInfo.access_token;

  switch(module) {
    case "auth":
      var url = auth_host + path;
      break;
    case "beacon":
      var url = beacon_host + path;
      break;
    case "ccp":
      var url = ccp_host + path;
      break;
    default:
      // code block
}
// let token = localStorage.getItem('token')
  let requestOptions = {};
  if (form !=null){
    requestOptions = {
        method: 'PUT',
        headers: {
          // "content-type": "multipart/form-data",
          Authorization: 'Bearer ' + token,
        },
        body: object,
      };
  }else{
    requestOptions = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify(object),
      };
  }
 return fetch(url, requestOptions).then(handleResponseStatus);
}

async function PostFetch(module,path, object,form =null) {
  if (localStorage.getItem(loginExpiryKey) - Math.floor(new Date().getTime() / 1000) <=0){
      await refreshToken()
  }
  var userInfo = getLocalStorageUserInfo();
  var token = userInfo.access_token;
  let requestOptions={}

  if (form !=null){
    requestOptions = {
        method: 'POST',
        headers: {
          // "content-type": "multipart/form-data",
          Authorization: 'Bearer ' + token,
        },
        body: object,
      };
  }else{
    requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify(object),
      };
  }
  switch(module) {
      case "auth":
        var url = auth_host + path;
        break;
      case "beacon":
        var url = beacon_host + path;
        break;
      case "ccp":
        var url = ccp_host + path;
        break;
      default:
        // code block
  }
  return fetch(url, requestOptions).then(handleResponseStatus);
}
async function PostCcpFetch(module,path, object,form =null) {
  if (localStorage.getItem(loginExpiryKey) - Math.floor(new Date().getTime() / 1000) <=0){
      await refreshToken()
  }
  var userInfo = getLocalStorageUserInfo();
  var token = userInfo.access_token;
  let requestOptions={}

  if (form !=null){
    requestOptions = {
        method: 'POST',
        headers: {
          // "content-type": "multipart/form-data",
          Authorization: 'Bearer ' + token,
        },
        body: object,
      };
  }else{
    requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify(object),
      };
  }
  switch(module) {
      case "auth":
        var url = auth_host + path;
        break;
      case "beacon":
        var url = beacon_host + path;
        break;
      case "ccp":
        var url = ccp_host + path;
        break;
      default:
        // code block
  }
  return fetch(url, requestOptions).then(handleCcpResponseStatus);
}
async function DeleteFetch(module,path) {
  if (localStorage.getItem(loginExpiryKey) - Math.floor(new Date().getTime() / 1000) <=0){
    await refreshToken()
  }
  var userInfo = getLocalStorageUserInfo();
  if (userInfo == undefined) {
    logout();
    location.reload(true);
    return;
  }
  var token = userInfo.access_token;

  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  };
  switch(module) {
      case "auth":
        var url = auth_host + path;
        break;
      case "beacon":
        var url = beacon_host + path;
        break;
      case "ccp":
        var url = ccp_host + path;
        break;
      default:
        // code block
  }

  return fetch(url, requestOptions).then(handleResponseStatus);
}

function handleResponseStatus(response) {
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      location.reload(true);
      // auto logout if 401 response returned from api
      // return Promise.reject(error);
    } else if (response.status === 403) {
      window.location.href = '/';

    } else if (response.status === 429) {
      return response
    }
    else {
      return response.text().then((text) => {
        const data = text && JSON.parse(text);
        const error = data.error;
        return Promise.reject(error);
      });
    }
  }
  return response;
}
function handleCcpResponseStatus(response) {
  if (!response.ok) {
    if (response.status === 401) {
        return response.text().then((text) => {
          const data = text && JSON.parse(text);
          const error = "Session timeout กรุณาทำซ้ำ";
          return Promise.reject(error);
      });
    } else if (response.status === 403) {
      window.location.href = '/';

    } else if (response.status === 429) {
      return response
    }
    else {
      return response.text().then((text) => {
        const data = text && JSON.parse(text);
        const error = data.error;
        return Promise.reject(error);
      });
    }
  }
  return response;
}
function getLocalStorageUserInfo() {
  var userInfo = localStorage.getItem('userinfo');
  if (userInfo == '' || userInfo == null || userInfo == undefined) {
    return undefined;
  } else {
    return JSON.parse(userInfo);
  }
}
